module.exports = __webpack_public_path__ + "assets/img/7202db0433fd2418a47e14d7bba020fc.png";